import { render, staticRenderFns } from "./TimeArgument.vue?vue&type=template&id=665432bc&scoped=true&"
import script from "./TimeArgument.vue?vue&type=script&lang=js&"
export * from "./TimeArgument.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "665432bc",
  null
  
)

export default component.exports